(function () {
  function initCleanGlowLanding(root) {
    if (!root || root.dataset.cglpInitialized === 'true') return;
    root.dataset.cglpInitialized = 'true';

    var anchorId = root.dataset.bundlesAnchor || '';
    var bundlesAnchor = anchorId ? document.getElementById(anchorId) : null;

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var heroOffersRotateId = null;
    var heroHotspotRotateId = null;
    /* Used by pricing/drawer helpers before bundle block initialization. */
    var cards = root.querySelectorAll('.cglp-bundle-card');

    root.querySelectorAll('.cglp-ugc-video').forEach(function (vid) {
      if (prefersReducedMotion) {
        vid.removeAttribute('autoplay');
        if (typeof vid.pause === 'function') vid.pause();
      }
    });

    function scrollToBundles() {
      var el = bundlesAnchor || root.querySelector('[id^="cglp-bundles"]');
      if (el) {
        el.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
        return true;
      }
      /* Sprint 3 fallback — when the mid-page bundles section is hidden
         (show_bundles: false per Ryan teardown #7), there is no anchor
         to scroll to. Route the click to the variant drawer instead so
         the CTA still converts. */
      var drawerBtn = root.querySelector('[data-cglp-ai-open-modal]');
      if (drawerBtn) {
        drawerBtn.click();
        return true;
      }
      return false;
    }

    root.querySelectorAll('[data-cglp-scroll-bundles]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToBundles();
      });
    });

    var heroOffersRoot = root.querySelector('[data-cglp-hero-offers]');
    if (heroOffersRoot) {
      var offersViewport = heroOffersRoot.querySelector('[data-cglp-hero-offers-viewport]');
      var offersStrip = heroOffersRoot.querySelector('[data-cglp-hero-offers-strip]');
      var offersLive = heroOffersRoot.querySelector('[data-cglp-hero-offers-live]');
      var offerSlides = offersStrip ? offersStrip.querySelectorAll('.cglp-hero-offers__slide') : [];
      var offerLines = offersStrip ? offersStrip.querySelectorAll('.cglp-hero-offers__line') : [];
      var useSlides = offerSlides.length > 0;
      var offerEls = useSlides ? offerSlides : offerLines;
      var lastHeroDiscountPct = -1;
      /* DOM index of each slide/line that has non-empty copy (strip translate uses DOM index) */
      var offerStripIndices = [];

      function heroOfferLiveText(el) {
        if (!el) return '';
        if (useSlides) {
          var a = el.getAttribute('data-cglp-hero-offer-live');
          return (a != null && a !== '' ? a : el.textContent).trim();
        }
        return el.textContent.trim();
      }

      function setHeroOfferIdx(rotIdx) {
        if (!offersViewport) return;
        if (!offerStripIndices.length) {
          offersViewport.style.setProperty('--cglp-offer-idx', '0');
          if (offersLive) offersLive.textContent = '';
          return;
        }
        var stripIdx = offerStripIndices[rotIdx];
        if (stripIdx === undefined) return;
        offersViewport.style.setProperty('--cglp-offer-idx', String(stripIdx));
        var el = offerEls[stripIdx];
        if (offersLive && el) offersLive.textContent = heroOfferLiveText(el);
        if (useSlides && offerSlides.length > 1 && !prefersReducedMotion) {
          var pct = parseInt(el.getAttribute('data-discount-pct'), 10) || 0;
          if (lastHeroDiscountPct >= 0 && pct > lastHeroDiscountPct) {
            heroOffersRoot.classList.remove('cglp-hero-offers--discount-up');
            void heroOffersRoot.offsetWidth;
            heroOffersRoot.classList.add('cglp-hero-offers--discount-up');
            window.setTimeout(function () {
              heroOffersRoot.classList.remove('cglp-hero-offers--discount-up');
            }, 700);
          }
          lastHeroDiscountPct = pct;
        }
      }

      var offerTexts = [];
      offerEls.forEach(function (el, idx) {
        var t = heroOfferLiveText(el);
        if (t) {
          offerTexts.push(t);
          offerStripIndices.push(idx);
        }
      });

      if (prefersReducedMotion && offerTexts.length > 1 && offersStrip) {
        heroOffersRoot.classList.add('cglp-hero-offers--static');
        offersStrip.innerHTML = '';
        var staticLine = document.createElement('span');
        staticLine.className = 'cglp-hero-offers__line cglp-hero-offers__line--static';
        staticLine.textContent = offerTexts.join(' · ');
        offersStrip.appendChild(staticLine);
        offerLines = offersStrip.querySelectorAll('.cglp-hero-offers__line');
        offerEls = offerLines;
        offerSlides = [];
        useSlides = false;
        lastHeroDiscountPct = -1;
        if (offersLive) offersLive.textContent = offerTexts.join('. ');
      } else if (offerTexts.length === 1) {
        var firstStrip = offerStripIndices[0];
        if (useSlides && firstStrip !== undefined && offerSlides[firstStrip]) {
          lastHeroDiscountPct =
            parseInt(offerSlides[firstStrip].getAttribute('data-discount-pct'), 10) || 0;
        }
        setHeroOfferIdx(0);
      } else if (offerTexts.length > 1) {
        var fs = offerStripIndices[0];
        if (useSlides && fs !== undefined && offerSlides[fs]) {
          lastHeroDiscountPct = parseInt(offerSlides[fs].getAttribute('data-discount-pct'), 10) || 0;
        } else {
          lastHeroDiscountPct = -1;
        }
        setHeroOfferIdx(0);
        var rotMs = parseInt(heroOffersRoot.getAttribute('data-cglp-hero-offers-interval'), 10) || 5000;
        var offerIdx = 0;
        heroOffersRotateId = window.setInterval(function () {
          offerIdx = (offerIdx + 1) % offerTexts.length;
          setHeroOfferIdx(offerIdx);
        }, rotMs);
      } else if (offerTexts.length === 0 && offerEls.length > 0) {
        setHeroOfferIdx(0);
      }
    }

    function scrollToFirstBundleCard() {
      var firstCard = root.querySelector('.cglp-bundle-card');
      var behavior = prefersReducedMotion ? 'auto' : 'smooth';
      if (firstCard) {
        firstCard.scrollIntoView({ behavior: behavior, block: 'center' });
        window.setTimeout(function () {
          try {
            firstCard.focus({ preventScroll: true });
          } catch (e2) {
            firstCard.focus();
          }
        }, 380);
        return;
      }
      scrollToBundles();
    }

    root.querySelectorAll('[data-cglp-bundles-head-jump]').forEach(function (head) {
      head.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToFirstBundleCard();
      });
      head.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          scrollToFirstBundleCard();
        }
      });
    });

    /* Variant drawer + add to cart (when section has a product) */
    var hasCartProduct = root.dataset.cglpHasCartProduct === 'true';
    var variantsJsonEl = root.querySelector('[data-cglp-variants-json]');
    var variantData = [];
    try {
      if (variantsJsonEl && variantsJsonEl.textContent) {
        variantData = JSON.parse(variantsJsonEl.textContent.trim());
      }
    } catch (err) {
      variantData = [];
    }
    if (!Array.isArray(variantData)) variantData = [];

    var drawer = root.querySelector('[data-cglp-variant-drawer]');
    var drawerPanel = drawer ? drawer.querySelector('.cglp-variant-drawer__panel') : null;
    var variantListEl = root.querySelector('[data-cglp-variant-list]');
    var hintEl = root.querySelector('[data-cglp-drawer-hint]');
    var bottleQtyInput = root.querySelector('[data-cglp-bottle-qty]');
    var bottleMinus = root.querySelector('[data-cglp-bottle-minus]');
    var bottlePlus = root.querySelector('[data-cglp-bottle-plus]');
    var variantLoadingEl = root.querySelector('[data-cglp-variant-loading]');
    var variantAddLocked = false;
    var lastDrawerFocus = null;
    var selectedVariantId = null;
    var selectedSellingPlanId = null;
    /* Sprint 5C P1.5: tracks the shade the user picked inline under the hero
       bundle-picker. When set, hero/sticky CTAs can bypass the variant drawer
       and go straight to ATC → checkout, and the drawer pre-selects this
       variant instead of the first-available fallback. */
    var inlineShadeVariantId = null;
    var drawerTimerEl = null;
    var drawerTimerId = null;
    var drawerTimerEndsAt = 0;

    function getBundleCardBottleCount() {
      var sel = root.querySelector('.cglp-bundle-card.is-selected');
      if (sel) {
        var n = parseInt(sel.getAttribute('data-bottle-count'), 10);
        if (!isNaN(n) && n >= 1) return Math.min(n, 99);
      }
      var hp = root.querySelector('[data-cglp-hero-pick].is-selected');
      if (hp) {
        var hn = parseInt(hp.getAttribute('data-bottle-count'), 10);
        if (!isNaN(hn) && hn >= 1) return Math.min(hn, 99);
      }
      return 1;
    }

    function getBottleCount() {
      if (drawer && !drawer.hasAttribute('hidden') && bottleQtyInput) {
        var n = parseInt(bottleQtyInput.value, 10);
        if (!isNaN(n) && n >= 1) {
          var max = parseInt(bottleQtyInput.getAttribute('max'), 10) || 99;
          return Math.min(n, max);
        }
      }
      return getBundleCardBottleCount();
    }

    function formatCents(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      var loc = (window.locale && window.locale.locale) || 'en-US';
      var cur = (window.locale && window.locale.currency) || 'USD';
      try {
        return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e2) {
        return (cents / 100).toFixed(2);
      }
    }

    function updateVariantDrawerIfOpen() {
      if (!drawer || drawer.hasAttribute('hidden')) return;
      if (bottleQtyInput) {
        bottleQtyInput.value = String(getBundleCardBottleCount());
      }
      updateDrawerPrices();
      syncCouponFromQty();
      updateStep1Summary();
    }

    function getCardForBottleCount(qty) {
      var parsedQty = parseInt(qty, 10) || 0;
      if (parsedQty < 1) return null;
      if (!cards || typeof cards.forEach !== 'function') return null;
      var found = null;
      cards.forEach(function (c) {
        var cbc = parseInt(c.getAttribute('data-bottle-count'), 10) || 0;
        if (cbc === parsedQty) found = c;
      });
      return found;
    }

    function getDiscountPct() {
      var qty = getBottleCount();
      var byQty = getCardForBottleCount(qty);
      if (!byQty && qty > 3) byQty = getCardForBottleCount(3);
      if (byQty) {
        var pctByQty = parseInt(byQty.getAttribute('data-discount-pct'), 10);
        return isNaN(pctByQty) ? 0 : pctByQty;
      }
      var sel = root.querySelector('.cglp-bundle-card.is-selected');
      if (sel) {
        var pct = parseInt(sel.getAttribute('data-discount-pct'), 10);
        return isNaN(pct) ? 0 : pct;
      }
      var hp = root.querySelector('[data-cglp-hero-pick].is-selected');
      if (hp) {
        var p2 = parseInt(hp.getAttribute('data-discount-pct'), 10);
        return isNaN(p2) ? 0 : p2;
      }
      return 0;
    }

    function getDiscountBubbleText() {
      var qty = getBottleCount();
      var byQty = getCardForBottleCount(qty);
      if (!byQty && qty > 3) byQty = getCardForBottleCount(3);
      if (byQty) return byQty.getAttribute('data-save-bubble') || '';
      var sel = root.querySelector('.cglp-bundle-card.is-selected');
      if (sel) return sel.getAttribute('data-save-bubble') || '';
      var hp = root.querySelector('[data-cglp-hero-pick].is-selected');
      if (hp) return hp.getAttribute('data-save-bubble') || '';
      return '';
    }

    function syncDrawerThumbs(qty) {
      var cap = qty;
      if (isNaN(cap) || cap < 1) cap = 1;
      if (cap > 6) cap = 6;
      root.querySelectorAll('[data-cglp-thumb-wrap]').forEach(function (wrap) {
        var url = wrap.getAttribute('data-cglp-thumb-src') || '';
        wrap.innerHTML = '';
        wrap.setAttribute('data-qty', String(cap));
        for (var i = 0; i < cap; i++) {
          if (url) {
            var im = document.createElement('img');
            im.src = url;
            im.alt = '';
            im.width = 80;
            im.height = 80;
            im.className = 'cglp-variant-drawer__thumb';
            im.loading = 'lazy';
            wrap.appendChild(im);
          } else {
            var ph = document.createElement('span');
            ph.className = 'cglp-variant-drawer__thumb cglp-variant-drawer__thumb--placeholder';
            ph.setAttribute('aria-hidden', 'true');
            wrap.appendChild(ph);
          }
        }
      });
    }

    function updateVariantRowAriaLabels(qty) {
      var soldLbl =
        window.variantStrings && window.variantStrings.soldOut ? window.variantStrings.soldOut : 'Sold out';
      var b = qty === 1 ? 'bottle' : 'bottles';
      root.querySelectorAll('[data-cglp-variant-row]').forEach(function (row) {
        var t = row.querySelector('.cglp-variant-drawer__name');
        var title = t ? t.textContent.trim() : '';
        var avail = row.getAttribute('data-available') === 'true';
        var suffix = ', ' + qty + ' ' + b;
        if (avail) row.setAttribute('aria-label', title + suffix);
        else row.setAttribute('aria-label', title + ', ' + soldLbl);
      });
    }

    function updateDrawerPrices() {
      var qty = getBottleCount();
      var discPct = getDiscountPct();
      var discBubbleText = getDiscountBubbleText();
      var tmpl = hintEl && hintEl.getAttribute('data-cglp-hint-template');
      if (hintEl && tmpl) {
        var bottlePhrase = qty === 1 ? '1 bottle' : qty + ' bottles';
        var out = tmpl.split('{bottles}').join(bottlePhrase);
        out = out.replace(/\bbottle\s+bottles\b/gi, 'bottle').replace(/\bbottles\s+bottles\b/gi, 'bottles');
        hintEl.textContent = out;
      }
      root.querySelectorAll('[data-cglp-variant-row]').forEach(function (row) {
        var unit = parseInt(row.getAttribute('data-unit-price'), 10) || 0;
        var uc = row.getAttribute('data-unit-compare');
        var unitCmp = uc ? parseInt(uc, 10) : 0;
        var total = unit * qty;
        var pEl = row.querySelector('[data-cglp-row-price]');
        var cEl = row.querySelector('[data-cglp-row-compare]');
        var dEl = row.querySelector('[data-cglp-row-discount-bubble]');

        /* Bundle %: strikethrough = max(unit*qty, variant_compare*qty); sale = unit*qty after bundle %. */
        var variantCompareTotal = unitCmp > unit ? unitCmp * qty : 0;
        var discountLabel = '';

        if (discPct > 0) {
          var compareCents = Math.max(total, variantCompareTotal);
          var discountedTotal = Math.round(total * (1 - discPct / 100));
          if (cEl) {
            if (compareCents > discountedTotal) {
              cEl.textContent = formatCents(compareCents);
              cEl.removeAttribute('hidden');
            } else {
              cEl.textContent = '';
              cEl.setAttribute('hidden', '');
            }
          }
          if (pEl) pEl.textContent = formatCents(discountedTotal);
          discountLabel = discPct + '% OFF';
          if (dEl) {
            dEl.textContent = discountLabel;
            dEl.removeAttribute('hidden');
          }
        } else {
          if (cEl) {
            if (unitCmp > 0 && unitCmp > unit) {
              cEl.textContent = formatCents(unitCmp * qty);
              cEl.removeAttribute('hidden');
            } else {
              cEl.textContent = '';
              cEl.setAttribute('hidden', '');
            }
          }
          if (pEl) pEl.textContent = formatCents(total);
          if (unitCmp > 0 && unitCmp > unit) {
            var poff = Math.round(((unitCmp - unit) / unitCmp) * 100);
            if (poff > 0) discountLabel = poff + '% off';
          }
          if (dEl) {
            if (discountLabel) {
              dEl.textContent = discountLabel;
              dEl.removeAttribute('hidden');
            } else {
              dEl.textContent = '';
              dEl.setAttribute('hidden', '');
            }
          }
        }
      });
      syncDrawerThumbs(qty);
      updateVariantRowAriaLabels(qty);
    }

    function setVariantDrawerLoading(on) {
      variantAddLocked = !!on;
      if (drawer) drawer.classList.toggle('cglp-variant-drawer--loading', !!on);
      if (drawerPanel) drawerPanel.setAttribute('aria-busy', on ? 'true' : 'false');
      if (variantLoadingEl) {
        if (on) {
          variantLoadingEl.removeAttribute('hidden');
          variantLoadingEl.setAttribute('aria-hidden', 'false');
        } else {
          variantLoadingEl.setAttribute('hidden', '');
          variantLoadingEl.setAttribute('aria-hidden', 'true');
        }
      }
      root.querySelectorAll('button[data-cglp-variant-drawer-dismiss]').forEach(function (el) {
        if (el instanceof HTMLButtonElement) el.disabled = !!on;
      });
      if (bottleMinus instanceof HTMLButtonElement) bottleMinus.disabled = !!on;
      if (bottlePlus instanceof HTMLButtonElement) bottlePlus.disabled = !!on;
      if (bottleQtyInput instanceof HTMLInputElement) bottleQtyInput.disabled = !!on;
      var chkBtn = root.querySelector('[data-cglp-drawer-checkout]');
      if (chkBtn) {
        chkBtn.disabled = !!on;
        chkBtn.classList.toggle('is-loading', !!on);
      }
      var clrBtn = root.querySelector('[data-cglp-drawer-clear-cart]');
      if (clrBtn instanceof HTMLButtonElement) clrBtn.disabled = !!on;
      root.querySelectorAll('[data-cglp-variant-row]').forEach(function (row) {
        if (!(row instanceof HTMLElement)) return;
        if (on) {
          if (!row.disabled) {
            row.setAttribute('data-cglp-temp-disabled', '');
            row.disabled = true;
          }
        } else if (row.hasAttribute('data-cglp-temp-disabled')) {
          row.removeAttribute('data-cglp-temp-disabled');
          var avail = row.getAttribute('data-available');
          row.disabled = avail === 'false';
        }
      });
    }

    function getDrawerFocusableEls() {
      if (!drawerPanel) return [];
      var sel =
        'a[href], button:not([disabled]):not([hidden]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return Array.prototype.slice.call(drawerPanel.querySelectorAll(sel)).filter(function (el) {
        if (!(el instanceof HTMLElement)) return false;
        if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false;
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
      });
    }

    function closeDrawer() {
      if (!drawer) return;
      if (variantAddLocked) return;
      selectedSellingPlanId = null;
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cglp-variant-drawer-open');
      document.removeEventListener('keydown', onDrawerKeydown);
      if (drawerTimerId) {
        window.clearInterval(drawerTimerId);
        drawerTimerId = null;
      }
      if (lastDrawerFocus && typeof lastDrawerFocus.focus === 'function') {
        lastDrawerFocus.focus();
      }
      lastDrawerFocus = null;
    }

    function onDrawerKeydown(e) {
      if (e.key === 'Escape') {
        if (variantAddLocked) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        closeDrawer();
        return;
      }
      if (e.key !== 'Tab' || !drawerPanel) return;
      var list = getDrawerFocusableEls();
      if (list.length === 0) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function startDrawerTimer() {
      drawerTimerEl = root.querySelector('[data-cglp-drawer-timer]');
      if (!drawerTimerEl) return;
      if (drawerTimerId) window.clearInterval(drawerTimerId);
      var seconds = parseInt(drawerTimerEl.getAttribute('data-cglp-drawer-timer-seconds'), 10) || 180;
      drawerTimerEndsAt = Date.now() + seconds * 1000;
      tickDrawerTimer();
      drawerTimerId = window.setInterval(tickDrawerTimer, 1000);
    }

    function tickDrawerTimer() {
      if (!drawerTimerEl) return;
      var ms = drawerTimerEndsAt - Date.now();
      if (ms <= 0) {
        drawerTimerEl.textContent = '0:00';
        if (drawerTimerId) {
          window.clearInterval(drawerTimerId);
          drawerTimerId = null;
        }
        return;
      }
      var s = Math.ceil(ms / 1000);
      var m = Math.floor(s / 60);
      var r = s % 60;
      drawerTimerEl.textContent = m + ':' + (r < 10 ? '0' : '') + r;
    }

    function tryOpenVariantDrawer(triggerEl) {
      if (!hasCartProduct || !variantData.length || !drawer || !drawerPanel) return;
      openDrawer(triggerEl || null);
    }

    /* Expose the stepped variant drawer opener so other scripts on the section
       (e.g. the AI modal fallback script) can prefer this drawer UX. */
    root.cglpOpenVariantDrawer = function (triggerEl) {
      tryOpenVariantDrawer(triggerEl);
    };

    /* Wire all hero/header AI modal triggers to the stepped variant drawer
       so the full drawer UI (step 1/2 accordion, caret, checkout, clear cart,
       countdown) is used everywhere the CTA opens. */
    root.querySelectorAll('[data-cglp-ai-open-modal]').forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (ev) {
          if (!hasCartProduct || !variantData.length || !drawer || !drawerPanel) return;
          /* Sprint 5C P1.5: if a shade is already chosen inline and the trigger
             is a hero/sticky CTA, bypass the drawer and fire a direct ATC →
             checkout. Fall through to the drawer otherwise so existing behavior
             is preserved. */
          var cls = (btn.className || '') + '';
          var isHeroLike =
            cls.indexOf('cglp-hero-cta') !== -1 ||
            cls.indexOf('cglp-btn-black--hero') !== -1 ||
            cls.indexOf('cglp-sticky-cta__btn') !== -1;
          if (selectedVariantId && isHeroLike && directAddToCartAndCheckout(btn)) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
          }
          ev.preventDefault();
          ev.stopImmediatePropagation();
          tryOpenVariantDrawer(btn);
        },
        true
      );
    });

    function openDrawer(fromEl) {
      if (!drawer || !drawerPanel) return;
      lastDrawerFocus = fromEl || null;
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      var drawerCheckoutBtnEnsure = root.querySelector('[data-cglp-drawer-checkout]');
      if (drawerCheckoutBtnEnsure) {
        drawerCheckoutBtnEnsure.hidden = false;
        drawerCheckoutBtnEnsure.removeAttribute('aria-hidden');
      }
      document.documentElement.classList.add('cglp-variant-drawer-open');
      if (bottleQtyInput) {
        bottleQtyInput.value = String(getBundleCardBottleCount());
      }
      updateDrawerPrices();
      syncCouponFromQty();
      setDrawerStep(2);
      document.addEventListener('keydown', onDrawerKeydown);
      drawerPanel.focus();
      selectedVariantId = null;
      /* Sprint 5C P1.5: if the shopper already picked a shade inline under
         the hero bundle-picker, pre-select that shade in the drawer instead
         of falling back to the first-available variant. */
      if (inlineShadeVariantId != null) {
        selectVariantRow(inlineShadeVariantId);
      } else {
        var firstAvail = null;
        for (var i = 0; i < variantData.length; i++) {
          if (variantData[i].available) { firstAvail = variantData[i]; break; }
        }
        if (firstAvail) selectVariantRow(firstAvail.id);
      }
      startDrawerTimer();
    }

    function getSelectedDiscountCode() {
      if (!hasCartProduct) return '';
      var qty = getBottleCount();
      var c1 = (root.getAttribute('data-cglp-coupon-1') || '').trim();
      var c2 = (root.getAttribute('data-cglp-coupon-2') || '').trim();
      var c3 = (root.getAttribute('data-cglp-coupon-3') || '').trim();
      if (qty <= 1) return c1;
      if (qty === 2) return c2;
      return c3;
    }

    function syncCouponFromQty() {
      if (!hasCartProduct || !window.liquidAjaxCart || typeof window.liquidAjaxCart.update !== 'function') return;
      var code = getSelectedDiscountCode();
      window.liquidAjaxCart.update({ discount: code || '' });
    }

    function clampBottleInput() {
      if (!bottleQtyInput) return;
      var min = parseInt(bottleQtyInput.getAttribute('min'), 10) || 1;
      var max = parseInt(bottleQtyInput.getAttribute('max'), 10) || 12;
      var n = parseInt(bottleQtyInput.value, 10);
      if (isNaN(n) || n < min) n = min;
      if (n > max) n = max;
      bottleQtyInput.value = String(n);
    }

    function onBottleQtyDirty() {
      clampBottleInput();
      updateDrawerPrices();
      syncCouponFromQty();
      updateStep1Summary();
    }

    function stepBottleQty(delta) {
      if (!bottleQtyInput) return;
      var min = parseInt(bottleQtyInput.getAttribute('min'), 10) || 1;
      var max = parseInt(bottleQtyInput.getAttribute('max'), 10) || 12;
      var n = parseInt(bottleQtyInput.value, 10);
      if (isNaN(n)) n = min;
      n = Math.min(max, Math.max(min, n + delta));
      bottleQtyInput.value = String(n);
      onBottleQtyDirty();
    }

    function afterAddToCartFlow(triggerEl) {
      closeDrawer();
      var behavior = root.dataset.cglpAfterAdd || 'checkout';
      var code = getSelectedDiscountCode();

      function openCartDrawer() {
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.open === 'function') cd.open(triggerEl);
      }

      if (behavior === 'checkout') {
        if (code) {
          window.location.href =
            '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
        } else {
          window.location.href = '/checkout';
        }
        return;
      }

      if (code && window.liquidAjaxCart && typeof window.liquidAjaxCart.update === 'function') {
        window.liquidAjaxCart.update({ discount: code });
      }
      window.setTimeout(openCartDrawer, 320);
    }

    function attachCouponForBundle() {
      syncCouponFromQty();
    }

    function addVariantLine(variantId, qty, triggerEl) {
      var line = { id: Number(variantId), quantity: qty };
      if (selectedSellingPlanId != null && selectedSellingPlanId !== '') {
        line.selling_plan = selectedSellingPlanId;
      }
      var body = { items: [line] };
      var afterAdd = root.dataset.cglpAfterAdd || 'checkout';
      var addOpts = {
        lastCallback: function (requestState) {
          setVariantDrawerLoading(false);
          var rd = requestState && requestState.responseData;
          var failed = rd && rd.ok === false;
          if (!failed) {
            afterAddToCartFlow(triggerEl);
          } else {
            showToast('Could not add to cart. Please try again.');
          }
        },
      };
      if (afterAdd === 'checkout') {
        addOpts.info = { should_keep_drawer_closed: true };
      }
      if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
        window.liquidAjaxCart.add(body, addOpts);
      } else {
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (res) {
            setVariantDrawerLoading(false);
            if (res.status) throw new Error(res.description || 'Cart error');
            afterAddToCartFlow(triggerEl);
          })
          .catch(function () {
            setVariantDrawerLoading(false);
            showToast('Could not add to cart. Please try again.');
          });
      }
    }

    /* Sprint 5C P1.5: direct "buy now" path wired from hero/sticky CTAs when
       a shade has already been chosen inline. Returns true when the ATC was
       dispatched; returns false so the caller can fall back to opening the
       variant drawer. Safe to call when the drawer loading state helpers are
       unavailable. */
    function directAddToCartAndCheckout(triggerEl) {
      if (!hasCartProduct || !selectedVariantId) return false;
      try {
        setVariantDrawerLoading(true);
      } catch (err) {
        /* noop — drawer elements may be absent; proceed with ATC anyway. */
      }
      var qty = getBottleCount();
      addVariantLine(selectedVariantId, qty, triggerEl);
      return true;
    }

    function handleAtcTrigger(e, triggerEl) {
      if (!hasCartProduct || !variantData.length) {
        scrollToBundles();
        return;
      }
      e.preventDefault();
      tryOpenVariantDrawer(triggerEl);
    }

    function updateStickyVariantTitle(variantId) {
      var stickyVar = root.querySelector('[data-cglp-sticky-variant]');
      if (!stickyVar || !variantData || !variantData.length) return;
      var found = null;
      for (var si = 0; si < variantData.length; si++) {
        if (String(variantData[si].id) === String(variantId)) {
          found = variantData[si];
          break;
        }
      }
      stickyVar.textContent = found && found.title ? found.title : '';
    }

    function syncHeroCtaLabel() {
      // P1.5 — once the visitor has chosen a shade, the hero CTA no longer
      // asks them to "Select Your Shade"; swap it to the merchant-authored
      // action label (e.g. "Checkout Now"). Sticky CTA left alone — its
      // label is purposefully short + mirrors system state elsewhere.
      var ctaBtns = root.querySelectorAll('[data-cglp-hero-cta]');
      if (!ctaBtns || !ctaBtns.length) return;
      ctaBtns.forEach(function (btn) {
        var labelEl = btn.querySelector('[data-cglp-hero-cta-label]');
        if (!labelEl) return;
        var def = btn.getAttribute('data-cta-label-default') || '';
        var withShade = btn.getAttribute('data-cta-label-with-shade') || '';
        if (selectedVariantId && withShade) {
          labelEl.textContent = withShade;
          btn.classList.add('is-shade-selected');
        } else {
          labelEl.textContent = def;
          btn.classList.remove('is-shade-selected');
        }
      });
    }

    function selectVariantRow(variantId) {
      selectedVariantId = variantId;
      root.querySelectorAll('[data-cglp-variant-row]').forEach(function (row) {
        var isMatch = row.getAttribute('data-variant-id') === String(variantId);
        row.classList.toggle('is-selected', isMatch);
        row.setAttribute('aria-checked', isMatch ? 'true' : 'false');
      });
      var checkoutBtn = root.querySelector('[data-cglp-drawer-checkout]');
      if (checkoutBtn) checkoutBtn.disabled = false;
      updateStickyVariantTitle(variantId);
      renderSellingPlanOptions(variantId);
      syncHeroCtaLabel();
    }

    var subWrap = root.querySelector('[data-cglp-subscription-wrap]');
    var subRadiosHost = root.querySelector('[data-cglp-selling-plan-radios]');
    var sectionIdAttr = (root.getAttribute('data-cglp-section-id') || 'cglp').replace(/\W/g, '');
    var showSubscriptions = root.getAttribute('data-cglp-show-subscriptions') === 'true';

    function renderSellingPlanOptions(variantId) {
      if (!subWrap || !subRadiosHost) return;
      if (!showSubscriptions) {
        selectedSellingPlanId = null; // One-time purchase default.
        subWrap.setAttribute('hidden', '');
        subRadiosHost.innerHTML = '';
        return;
      }
      var v = null;
      for (var i = 0; i < variantData.length; i++) {
        if (String(variantData[i].id) === String(variantId)) {
          v = variantData[i];
          break;
        }
      }
      var plans = v && v.selling_plans && v.selling_plans.length ? v.selling_plans : [];
      subRadiosHost.innerHTML = '';
      selectedSellingPlanId = null;
      if (!plans.length) {
        subWrap.setAttribute('hidden', '');
        return;
      }
      subWrap.removeAttribute('hidden');
      var gName = 'cglp-sp-' + sectionIdAttr;
      var oneTimeLbl =
        (window.variantStrings && window.variantStrings.oneTimePurchase) || 'One-time purchase';
      var r0 = document.createElement('label');
      r0.className = 'cglp-variant-drawer__sp-label';
      var inp0 = document.createElement('input');
      inp0.type = 'radio';
      inp0.name = gName;
      inp0.value = '';
      inp0.checked = true;
      inp0.addEventListener('change', function () {
        if (inp0.checked) selectedSellingPlanId = null;
      });
      r0.appendChild(inp0);
      r0.appendChild(document.createTextNode(' ' + oneTimeLbl));
      subRadiosHost.appendChild(r0);
      plans.forEach(function (sp) {
        var rl = document.createElement('label');
        rl.className = 'cglp-variant-drawer__sp-label';
        var inp = document.createElement('input');
        inp.type = 'radio';
        inp.name = gName;
        inp.value = String(sp.id);
        inp.addEventListener('change', function () {
          if (inp.checked) selectedSellingPlanId = Number(sp.id);
        });
        rl.appendChild(inp);
        rl.appendChild(document.createTextNode(' ' + (sp.name || 'Subscribe')));
        subRadiosHost.appendChild(rl);
      });
    }

    function buildVariantRows() {
      if (!variantListEl || !variantData.length) return;
      variantListEl.innerHTML = '';
      var bsVariant = (root.getAttribute('data-cglp-best-seller-variant') || '').trim().toLowerCase();
      var bsLabel = (root.getAttribute('data-cglp-best-seller-label') || 'BEST SELLER').trim();

      variantData.forEach(function (v) {
        var li = document.createElement('li');
        li.className = 'cglp-variant-drawer__item';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cglp-variant-drawer__row';
        btn.setAttribute('data-cglp-variant-row', '');
        btn.setAttribute('data-variant-id', String(v.id));
        btn.setAttribute('data-unit-price', String(v.price));
        btn.setAttribute('data-unit-compare', v.compare_at_price != null ? String(v.compare_at_price) : '');
        btn.setAttribute('data-available', v.available ? 'true' : 'false');
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', 'false');
        if (!v.available) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        }
        var soldLbl = window.variantStrings && window.variantStrings.soldOut ? window.variantStrings.soldOut : 'Sold out';
        var isBestSeller = v.best_seller === true || (bsVariant && v.title.toLowerCase() === bsVariant);
        if (isBestSeller) {
          var badge = document.createElement('span');
          badge.className = 'cglp-variant-drawer__best-seller';
          badge.textContent = bsLabel;
          btn.appendChild(badge);
        }

        var tw = document.createElement('span');
        tw.className = 'cglp-variant-drawer__thumb-wrap';
        tw.setAttribute('data-cglp-thumb-src', v.image || '');
        tw.setAttribute('data-cglp-thumb-wrap', '');

        var meta = document.createElement('span');
        meta.className = 'cglp-variant-drawer__meta';
        var name = document.createElement('span');
        name.className = 'cglp-variant-drawer__name';
        name.textContent = v.title;
        if (v.best_for) {
          var bfEl = document.createElement('span');
          bfEl.className = 'cglp-variant-drawer__best-for';
          bfEl.textContent = v.best_for;
          meta.appendChild(bfEl);
        }
        meta.appendChild(name);
        if (v.detail) {
          var detEl = document.createElement('span');
          detEl.className = 'cglp-variant-drawer__detail';
          detEl.textContent = v.detail;
          meta.appendChild(detEl);
        }
        var prices = document.createElement('span');
        prices.className = 'cglp-variant-drawer__prices';
        var cmp = document.createElement('s');
        cmp.className = 'cglp-variant-drawer__compare';
        cmp.setAttribute('data-cglp-row-compare', '');
        cmp.setAttribute('hidden', '');
        var pr = document.createElement('span');
        pr.className = 'cglp-variant-drawer__row-price';
        pr.setAttribute('data-cglp-row-price', '');
        prices.appendChild(cmp);
        prices.appendChild(document.createTextNode(' '));
        prices.appendChild(pr);
        meta.appendChild(prices);

        var qty0 = getBottleCount();
        var bq = qty0 === 1 ? 'bottle' : 'bottles';
        btn.setAttribute(
          'aria-label',
          v.available ? v.title + ', ' + qty0 + ' ' + bq : v.title + ', ' + soldLbl
        );

        var discBubble = document.createElement('span');
        discBubble.className = 'cglp-variant-drawer__row-discount';
        discBubble.setAttribute('data-cglp-row-discount-bubble', '');
        discBubble.setAttribute('hidden', '');

        btn.appendChild(tw);
        btn.appendChild(meta);
        btn.appendChild(discBubble);
        li.appendChild(btn);
        variantListEl.appendChild(li);

        btn.addEventListener('click', function () {
          if (!v.available || variantAddLocked) return;
          selectVariantRow(v.id);
        });
      });
    }

    if (drawer && variantListEl && variantData.length) {
      buildVariantRows();
      updateDrawerPrices();
      drawer.setAttribute('aria-hidden', 'true');
    }

    if (drawer) {
      drawer.querySelectorAll('[data-cglp-variant-drawer-dismiss]').forEach(function (el) {
        el.addEventListener('click', function () {
          closeDrawer();
        });
      });

      /* Safety net: close drawer on any click that lands outside the panel.
         This catches cases where the backdrop div misses the click (e.g.
         stacking, pointer-events, third-party injected wrappers). Also
         handles touchstart so iOS fires before any scroll intercept. */
      var dismissOnOutside = function (ev) {
        if (!drawer || drawer.hasAttribute('hidden')) return;
        if (variantAddLocked) return;
        var target = ev.target;
        if (!(target instanceof Node)) return;
        if (drawerPanel && drawerPanel.contains(target)) return;
        closeDrawer();
      };
      drawer.addEventListener('click', dismissOnOutside);
      drawer.addEventListener('touchstart', dismissOnOutside, { passive: true });
    }

    var drawerCheckoutBtn = root.querySelector('[data-cglp-drawer-checkout]');
    if (drawer && drawerCheckoutBtn) {
      drawerCheckoutBtn.addEventListener('click', function () {
        if (!selectedVariantId || variantAddLocked) return;
        setVariantDrawerLoading(true);
        addVariantLine(selectedVariantId, getBottleCount(), drawerCheckoutBtn);
      });
    }

    var drawerClearCartBtn = root.querySelector('[data-cglp-drawer-clear-cart]');
    if (drawer && drawerClearCartBtn) {
      drawerClearCartBtn.addEventListener('click', function () {
        if (variantAddLocked) return;
        drawerClearCartBtn.disabled = true;
        fetch('/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        })
          .then(function () {
            if (window.liquidAjaxCart && typeof window.liquidAjaxCart.getCart === 'function') {
              try {
                window.liquidAjaxCart.getCart();
              } catch (e) {
                /* ignore */
              }
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          })
          .catch(function () {
            /* ignore */
          })
          .finally(function () {
            drawerClearCartBtn.disabled = false;
          });
      });
    }

    if (drawer && bottleQtyInput) {
      bottleQtyInput.addEventListener('change', onBottleQtyDirty);
      bottleQtyInput.addEventListener('blur', onBottleQtyDirty);
      bottleQtyInput.addEventListener('input', function () {
        updateDrawerPrices();
        syncCouponFromQty();
      });
    }
    if (drawer && bottleMinus) {
      bottleMinus.addEventListener('click', function () {
        stepBottleQty(-1);
      });
    }
    if (drawer && bottlePlus) {
      bottlePlus.addEventListener('click', function () {
        stepBottleQty(1);
      });
    }

    /* ── Stepped drawer logic ── */
    var step1El = root.querySelector('[data-cglp-step="1"]');
    var step2El = root.querySelector('[data-cglp-step="2"]');
    var step1Summary = root.querySelector('[data-cglp-step1-summary]');
    var step1SummaryValue = root.querySelector('[data-cglp-step1-summary-value]');
    var step1ToggleBtn = step1El ? step1El.querySelector('[data-cglp-step-toggle]') : null;

    function updateStep1Summary() {
      var qty = getBottleCount();
      var pct = getDiscountPct();
      var card = root.querySelector('.cglp-bundle-card.is-selected');
      var bundleTitle = '';
      if (card) {
        var intro = (card.getAttribute('data-aria-intro') || '').trim();
        if (intro) {
          var c = intro.indexOf(',');
          bundleTitle = c >= 0 ? intro.slice(0, c).trim() : intro;
        }
      }
      var parts = [];
      if (bundleTitle) parts.push(bundleTitle);
      parts.push(qty + (qty === 1 ? ' bottle' : ' bottles'));
      if (pct > 0) parts.push(pct + '% OFF');
      var txt = parts.join(' · ');
      if (step1SummaryValue) step1SummaryValue.textContent = txt;
      else if (step1Summary) step1Summary.textContent = txt;
      if (step1ToggleBtn) {
        var stepLblEl = step1ToggleBtn.querySelector('.cglp-step__label');
        var stepLbl = (stepLblEl && stepLblEl.textContent.trim()) || 'Bottle quantity';
        step1ToggleBtn.setAttribute(
          'aria-label',
          stepLbl + '. Selected: ' + txt + '. Press to change quantity.'
        );
      }
    }

    function setDrawerStep(n) {
      if (!step1El || !step2El) return;
      if (n === 1) {
        step1El.classList.remove('is-collapsed');
        step1El.classList.add('is-active');
        step2El.classList.add('is-collapsed');
        step2El.classList.remove('is-active');
        var toggle1 = step1El.querySelector('[data-cglp-step-toggle]');
        if (toggle1) {
          toggle1.setAttribute('aria-expanded', 'true');
          toggle1.removeAttribute('aria-label');
        }
      } else {
        updateStep1Summary();
        step1El.classList.add('is-collapsed');
        step1El.classList.remove('is-active');
        step2El.classList.remove('is-collapsed');
        step2El.classList.add('is-active');
        var toggle1b = step1El.querySelector('[data-cglp-step-toggle]');
        if (toggle1b) toggle1b.setAttribute('aria-expanded', 'false');
      }
    }

    try {
      if (step1El) {
        var step1Toggle = step1El.querySelector('[data-cglp-step-toggle]');
        if (step1Toggle) {
          step1Toggle.addEventListener('click', function () {
            var isCollapsed = step1El.classList.contains('is-collapsed');
            setDrawerStep(isCollapsed ? 1 : 2);
          });
        }
        var step1Continue = step1El.querySelector('[data-cglp-step-continue]');
        if (step1Continue) {
          step1Continue.addEventListener('click', function () {
            setDrawerStep(2);
          });
        }
      }
    } catch (drawerStepErr) {
      console.warn('[CGLP] Drawer step controls unavailable', drawerStepErr);
    }

    /* ── Drawer Step 1 bundle radiogroup ─────────────────────────────
       Clicking / keyboard-activating a bundle radio delegates to the
       existing selectBundle(matchCard) so hero picks, sticky CTA,
       coupons, and drawer prices stay in sync. Then auto-advance to
       Step 2. Arrow keys + Home/End provide APG radiogroup behavior. */
    var drawerBundlesEl = root.querySelector('[data-cglp-drawer-bundles]');
    if (drawerBundlesEl) {
      var drawerBundleRadios = Array.prototype.slice.call(
        drawerBundlesEl.querySelectorAll('[data-cglp-drawer-bundle]')
      );

      function selectDrawerBundle(radio) {
        if (!radio) return;
        drawerBundleRadios.forEach(function (r) {
          var isSel = r === radio;
          r.classList.toggle('is-selected', isSel);
          r.setAttribute('aria-checked', isSel ? 'true' : 'false');
          r.setAttribute('tabindex', isSel ? '0' : '-1');
        });
        var bc = radio.getAttribute('data-bottle-count');
        var matchCard = bc
          ? root.querySelector('.cglp-bundle-card[data-bottle-count="' + bc + '"]')
          : null;
        if (matchCard && typeof selectBundle === 'function') {
          selectBundle(matchCard);
        } else {
          /* Fallback: at least reflect in drawer prices/summary */
          updateDrawerPrices();
          syncCouponFromQty();
          if (typeof updateStep1Summary === 'function') updateStep1Summary();
        }
        setDrawerStep(2);
      }

      function focusDrawerBundle(idx) {
        if (idx < 0) idx = drawerBundleRadios.length - 1;
        if (idx >= drawerBundleRadios.length) idx = 0;
        var el = drawerBundleRadios[idx];
        if (!el) return;
        /* APG roving-tabindex: only the focused option is in the tab order. */
        drawerBundleRadios.forEach(function (r) {
          r.setAttribute('tabindex', r === el ? '0' : '-1');
        });
        if (typeof el.focus === 'function') el.focus();
      }

      drawerBundleRadios.forEach(function (radio, idx) {
        radio.addEventListener('click', function () {
          selectDrawerBundle(radio);
        });
        radio.addEventListener('keydown', function (ev) {
          var key = ev.key;
          if (key === 'ArrowRight' || key === 'ArrowDown') {
            ev.preventDefault();
            focusDrawerBundle(idx + 1);
          } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
            ev.preventDefault();
            focusDrawerBundle(idx - 1);
          } else if (key === 'Home') {
            ev.preventDefault();
            focusDrawerBundle(0);
          } else if (key === 'End') {
            ev.preventDefault();
            focusDrawerBundle(drawerBundleRadios.length - 1);
          } else if (key === ' ' || key === 'Enter') {
            ev.preventDefault();
            selectDrawerBundle(radio);
          }
        });
      });

      /* Keep drawer radios mirrored to the section's active bundle card
         when the user changes selection outside the drawer. */
      function syncDrawerBundlesFromCard() {
        var sel = root.querySelector('.cglp-bundle-card.is-selected');
        var bc = sel ? sel.getAttribute('data-bottle-count') : null;
        if (!bc) return;
        drawerBundleRadios.forEach(function (r) {
          var match = r.getAttribute('data-bottle-count') === String(bc);
          r.classList.toggle('is-selected', match);
          r.setAttribute('aria-checked', match ? 'true' : 'false');
          r.setAttribute('tabindex', match ? '0' : '-1');
        });
      }
      /* Expose so selectBundle can trigger a refresh (wrapped below). */
      root.cglpSyncDrawerBundles = syncDrawerBundlesFromCard;
    }

    root.querySelectorAll('[data-cglp-atc-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        handleAtcTrigger(e, btn);
      });
    });

    /* Routine steps */
    var triggers = root.querySelectorAll('.cglp-routine-trigger');
    var previewStack = root.querySelector('[data-cglp-routine-preview-stack]');
    var previewImg = root.querySelector('[data-cglp-routine-preview-img]');
    var previewVid = root.querySelector('[data-cglp-routine-preview-video]');
    var routineMediaWrap = root.querySelector('[data-cglp-routine-fallback-src]');
    var playBtn = root.querySelector('[data-cglp-video-play]');
    if (prefersReducedMotion && previewVid) {
      previewVid.removeAttribute('autoplay');
      if (typeof previewVid.pause === 'function') previewVid.pause();
    }
    var progressFill = root.querySelector('[data-cglp-video-progress]');
    var timeEl = root.querySelector('[data-cglp-video-time]');
    var stepCount = triggers.length || 1;
    var routineViewportVideo = root.getAttribute('data-cglp-routine-viewport-video') === 'true';
    var previewVidIO = null;

    function disconnectPreviewVidIO() {
      if (previewVidIO && previewVid) {
        try {
          previewVidIO.unobserve(previewVid);
        } catch (e1) {
          /* ignore */
        }
        previewVidIO.disconnect();
        previewVidIO = null;
      }
    }

    function tryRoutineViewportPlayFallback() {
      if (!routineViewportVideo || !previewVid || previewVid.hidden || prefersReducedMotion) return;
      var r = previewVid.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight || 0;
      if (h < 1 || r.height < 1) return;
      /* IO can miss the first frame after source swap; nudge play when clearly in view */
      if (r.bottom > 0 && r.top < h * 0.92) {
        var p = previewVid.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    }

    function connectPreviewVidIO() {
      disconnectPreviewVidIO();
      if (!routineViewportVideo || !previewVid || prefersReducedMotion || previewVid.hidden) return;
      if (typeof IntersectionObserver !== 'function') {
        tryRoutineViewportPlayFallback();
        return;
      }
      previewVidIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (!previewVid || previewVid.hidden) return;
            if (en.isIntersecting && en.intersectionRatio >= 0.25) {
              var p = previewVid.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else {
              previewVid.pause();
            }
          });
        },
        { threshold: [0, 0.25, 0.5], rootMargin: '0px 0px -5% 0px' }
      );
      previewVidIO.observe(previewVid);
      window.requestAnimationFrame(function () {
        tryRoutineViewportPlayFallback();
      });
    }

    function onPreviewVidVisibilityChange() {
      if (!previewVid || !root.contains(previewVid) || previewVid.hidden) return;
      if (document.hidden) {
        previewVid.pause();
      }
    }
    document.addEventListener('visibilitychange', onPreviewVidVisibilityChange);

    function setRoutinePreviewLoading(on) {
      if (!previewStack) return;
      previewStack.classList.toggle('cglp-routine-preview-stack--loading', !!on);
      previewStack.setAttribute('data-cglp-routine-preview-loading', on ? 'true' : 'false');
      previewStack.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function syncRoutinePlayButton(previewKind) {
      if (!playBtn) return;
      var url = (playBtn.getAttribute('data-video-url') || '').trim();
      if (!url.length) return;
      playBtn.hidden = previewKind === 'video';
    }

    function activateStep(btn) {
      triggers.forEach(function (t) {
        var active = t === btn;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-expanded', active ? 'true' : 'false');
        var detail = t.querySelector('.cglp-routine-detail');
        if (detail) detail.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      var kind = btn.getAttribute('data-routine-preview-kind') || 'none';
      var imgSrc = (btn.getAttribute('data-routine-img-src') || '').trim();
      var videoSrc = (btn.getAttribute('data-routine-video-src') || '').trim();
      var videoType = btn.getAttribute('data-routine-video-type') || 'video/mp4';
      var videoPoster = (btn.getAttribute('data-routine-video-poster') || '').trim();
      var stepLabel = (btn.getAttribute('data-routine-step-label') || '').trim();
      var fallbackSrc = routineMediaWrap ? (routineMediaWrap.getAttribute('data-cglp-routine-fallback-src') || '').trim() : '';
      var idx = parseInt(btn.getAttribute('data-step-index'), 10) || 1;
      var activeCap = root.querySelector('[data-cglp-routine-active-label]');
      if (activeCap) {
        activeCap.textContent = stepLabel;
      }

      if (previewStack) previewStack.style.opacity = '1';

      /* Apply preview in the same turn as the click so video.play() stays user-activated (mobile Safari). */
      if (kind === 'video' && videoSrc && previewVid && previewImg) {
        disconnectPreviewVidIO();
        setRoutinePreviewLoading(true);
        previewImg.hidden = true;
        previewVid.hidden = false;
        previewVid.innerHTML = '';
        var s = document.createElement('source');
        s.src = videoSrc;
        s.type = videoType;
        previewVid.appendChild(s);
        if (videoPoster) {
          previewVid.setAttribute('poster', videoPoster);
        } else {
          previewVid.removeAttribute('poster');
        }
        if (stepLabel) {
          previewVid.setAttribute('aria-label', stepLabel);
        }
        /* Detach any prior auto-advance handler from previous step's video. */
        if (previewVid._cglpEndedHandler) {
          previewVid.removeEventListener('ended', previewVid._cglpEndedHandler);
          previewVid._cglpEndedHandler = null;
        }
        var onVidEnded = function () {
          if (prefersReducedMotion) return;
          var currentIdx = parseInt(btn.getAttribute('data-step-index'), 10) || 1;
          var nextBtn = null;
          triggers.forEach(function (t) {
            if (nextBtn) return;
            var ti = parseInt(t.getAttribute('data-step-index'), 10) || 0;
            if (ti === currentIdx + 1) nextBtn = t;
          });
          if (nextBtn) activateStep(nextBtn);
        };
        previewVid.addEventListener('ended', onVidEnded);
        previewVid._cglpEndedHandler = onVidEnded;
        function attemptInlinePlay() {
          if (!previewVid || prefersReducedMotion) return;
          var p = previewVid.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }
        var onVidReady = function () {
          setRoutinePreviewLoading(false);
          previewVid.removeEventListener('loadeddata', onVidReady);
          previewVid.removeEventListener('canplay', onVidCanPlay);
          previewVid.removeEventListener('error', onVidErr);
          if (!prefersReducedMotion && routineViewportVideo) {
            tryRoutineViewportPlayFallback();
          } else if (!routineViewportVideo) {
            attemptInlinePlay();
          }
        };
        var onVidCanPlay = function () {
          if (!prefersReducedMotion && !routineViewportVideo) {
            attemptInlinePlay();
          }
        };
        var onVidErr = function () {
          setRoutinePreviewLoading(false);
          previewVid.removeEventListener('loadeddata', onVidReady);
          previewVid.removeEventListener('canplay', onVidCanPlay);
          previewVid.removeEventListener('error', onVidErr);
        };
        previewVid.addEventListener('loadeddata', onVidReady);
        previewVid.addEventListener('canplay', onVidCanPlay);
        previewVid.addEventListener('error', onVidErr);
        previewVid.load();
        if (!prefersReducedMotion) {
          if (routineViewportVideo) {
            previewVid.removeAttribute('autoplay');
            connectPreviewVidIO();
          } else {
            previewVid.setAttribute('autoplay', '');
            attemptInlinePlay();
          }
        } else {
          previewVid.removeAttribute('autoplay');
          previewVid.pause();
        }
        syncRoutinePlayButton('video');
      } else {
        disconnectPreviewVidIO();
        setRoutinePreviewLoading(false);
        if (previewVid) {
          previewVid.pause();
          previewVid.innerHTML = '';
          previewVid.hidden = true;
          if (previewVid._cglpEndedHandler) {
            previewVid.removeEventListener('ended', previewVid._cglpEndedHandler);
            previewVid._cglpEndedHandler = null;
          }
        }
        if (previewImg) {
          previewImg.hidden = false;
          var nextSrc = imgSrc || fallbackSrc;
          if (nextSrc) previewImg.setAttribute('src', nextSrc);
        }
        syncRoutinePlayButton('image');
      }
      if (previewStack) previewStack.style.opacity = '1';

      if (progressFill) {
        progressFill.style.width = Math.min(100, (idx / stepCount) * 100) + '%';
      }
      if (timeEl) {
        var sec = idx + 3;
        timeEl.textContent = '0:' + (sec < 10 ? '0' : '') + sec;
      }
    }

    function bindRoutineClickHandler(hostEl) {
      if (!hostEl || hostEl.dataset.cglpRoutineBound === 'true') return;
      hostEl.dataset.cglpRoutineBound = 'true';
      hostEl.addEventListener('click', function (evt) {
        var target = evt.target;
        if (!(target instanceof Element)) return;
        var btn = target.closest('.cglp-routine-trigger');
        if (!btn || !hostEl.contains(btn)) return;
        activateStep(btn);
      });
    }

    bindRoutineClickHandler(root.querySelector('[data-cglp-routine-steps]'));

    var initialRoutine = root.querySelector('.cglp-routine-trigger.is-active');
    if (initialRoutine) {
      activateStep(initialRoutine);
    } else if (triggers.length) {
      activateStep(triggers[0]);
    }

    var routineJumpBtn = root.querySelector('[data-cglp-routine-steps-jump]');
    var routineStepsHost = root.querySelector('[data-cglp-routine-steps]');
    if (routineJumpBtn) {
      routineJumpBtn.addEventListener('click', function () {
        var behavior = prefersReducedMotion ? 'auto' : 'smooth';
        if (triggers.length) {
          var firstStep = triggers[0];
          firstStep.scrollIntoView({ behavior: behavior, block: 'center' });
          window.setTimeout(function () {
            try {
              firstStep.focus({ preventScroll: true });
            } catch (e) {
              firstStep.focus();
            }
          }, 380);
          return;
        }
        if (routineStepsHost) {
          routineStepsHost.scrollIntoView({ behavior: behavior, block: 'start' });
          return;
        }
        scrollToFirstBundleCard();
      });
    }

    /* Bundle cards */
    var priceNow = root.querySelector('[data-cglp-header-price-now]');
    var priceWas = root.querySelector('[data-cglp-header-price-was]');
    var heroCtaNow = root.querySelector('[data-cglp-hero-cta-now]');
    var heroCtaWas = root.querySelector('[data-cglp-hero-cta-was]');
    /* Sprint 3 — below-CTA price-line mirrors (Sharma Immediate Action #7).
       Populated from the same source as heroCtaNow/Was so the in-pill and
       below-pill prices never drift. `save` attr carries "SAVE 20%" derived
       from the active data-save-bubble (falls back to data-save-header). */
    var heroCtaNowMirror = root.querySelector('[data-cglp-hero-cta-now-mirror]');
    var heroCtaWasMirror = root.querySelector('[data-cglp-hero-cta-was-mirror]');
    var heroCtaSaveMirror = root.querySelector('[data-cglp-hero-cta-save-mirror]');
    function syncHeroCtaPriceLine(now, was, saveBubble, saveHeader) {
      if (heroCtaNowMirror) heroCtaNowMirror.textContent = now || '';
      if (heroCtaWasMirror) {
        heroCtaWasMirror.textContent = was || '';
        heroCtaWasMirror.style.display = was ? '' : 'none';
      }
      if (heroCtaSaveMirror) {
        var label = '';
        if (saveHeader) {
          label = saveHeader;
        } else if (saveBubble) {
          var m = String(saveBubble).match(/(\d+)/);
          if (m) label = 'SAVE ' + m[1] + '%';
        }
        heroCtaSaveMirror.textContent = label;
        heroCtaSaveMirror.style.display = label ? '' : 'none';
      }
    }
    var bubble = root.querySelector('[data-cglp-savings-bubble]');
    var headerSave = root.querySelector('[data-cglp-header-save-badge]');
    var shineBtn = root.querySelector('.cglp-btn-black--shine');
    var bundleCheckout = root.querySelector('[data-cglp-bundle-checkout]');
    var checkoutLineWas = root.querySelector('[data-cglp-checkout-line-was]');
    var checkoutLineNow = root.querySelector('[data-cglp-checkout-line-now]');
    var checkoutBtnWas = root.querySelector('[data-cglp-checkout-btn-was]');
    var checkoutBtnNow = root.querySelector('[data-cglp-checkout-btn-now]');
    var reserveTimerEl = root.querySelector('[data-cglp-reserve-timer]');
    var reserveTimerId = null;
    var reserveEndsAt = 0;

    function parseReserveSeconds() {
      if (!bundleCheckout) return 120;
      var raw = parseInt(bundleCheckout.getAttribute('data-cglp-reserve-seconds'), 10);
      if (isNaN(raw) || raw < 1) return 120;
      return raw;
    }

    function formatCountdownMs(ms) {
      var s = Math.max(0, Math.ceil(ms / 1000));
      var m = Math.floor(s / 60);
      var r = s % 60;
      return m + ':' + (r < 10 ? '0' : '') + r;
    }

    function reserveAriaLabel(secondsLeft) {
      var m = Math.floor(secondsLeft / 60);
      var r = secondsLeft % 60;
      if (m <= 0) return r + ' seconds remaining on reservation hold';
      if (r === 0) return m + ' minute' + (m === 1 ? '' : 's') + ' remaining on reservation hold';
      return m + ' minute' + (m === 1 ? '' : 's') + ' ' + r + ' seconds remaining on reservation hold';
    }

    function tickReserveTimer() {
      if (!reserveTimerEl) return;
      var ms = reserveEndsAt - Date.now();
      if (ms <= 0) {
        reserveTimerEl.textContent = '0:00';
        reserveTimerEl.setAttribute('aria-label', 'Reservation hold ended');
        if (reserveTimerId) {
          window.clearInterval(reserveTimerId);
          reserveTimerId = null;
        }
        return;
      }
      var secLeft = Math.ceil(ms / 1000);
      reserveTimerEl.textContent = formatCountdownMs(ms);
      reserveTimerEl.setAttribute('aria-label', reserveAriaLabel(secLeft));
    }

    function startReserveCountdown() {
      if (!reserveTimerEl) return;
      if (reserveTimerId) window.clearInterval(reserveTimerId);
      var totalSec = parseReserveSeconds();
      reserveEndsAt = Date.now() + totalSec * 1000;
      tickReserveTimer();
      reserveTimerId = window.setInterval(tickReserveTimer, 1000);
    }

    function syncBundleCheckoutFromCard(card) {
      if (!bundleCheckout || !card) return;
      var now = card.getAttribute('data-price-now') || '';
      var was = card.getAttribute('data-price-was') || '';
      if (checkoutLineWas) {
        checkoutLineWas.textContent = was;
        checkoutLineWas.style.display = was ? '' : 'none';
      }
      if (checkoutLineNow) checkoutLineNow.textContent = now;
      if (checkoutBtnWas) {
        checkoutBtnWas.textContent = was;
        checkoutBtnWas.style.display = was ? '' : 'none';
      }
      if (checkoutBtnNow) checkoutBtnNow.textContent = now;
      var checkoutBtnEl = bundleCheckout.querySelector('.cglp-bundle-checkout__btn');
      if (checkoutBtnEl) {
        var lblEl = checkoutBtnEl.querySelector('.cglp-bundle-checkout__btn-label');
        var labelText = lblEl && lblEl.textContent ? lblEl.textContent.trim() : 'Checkout now';
        checkoutBtnEl.setAttribute(
          'aria-label',
          was ? labelText + ', compare at ' + was + ', your price ' + now : labelText + ', price ' + now
        );
      }
      startReserveCountdown();
    }

    function syncBundleCardAriaLabels() {
      cards.forEach(function (c) {
        var intro = c.getAttribute('data-aria-intro') || '';
        var now = c.getAttribute('data-price-now') || '';
        var was = c.getAttribute('data-price-was') || '';
        var save = c.getAttribute('data-save-label') || '';
        c.setAttribute(
          'aria-label',
          [intro, 'Now ' + now + ', was ' + was + '.', save].filter(Boolean).join(' ')
        );
      });
    }

    function selectBundle(card) {
      if (!card) return;
      cards.forEach(function (c) {
        c.classList.toggle('is-selected', c === card);
        c.setAttribute('aria-pressed', c === card ? 'true' : 'false');
      });
      if (priceNow) priceNow.textContent = card.getAttribute('data-price-now') || '';
      if (priceWas) priceWas.textContent = card.getAttribute('data-price-was') || '';
      if (heroCtaNow) heroCtaNow.textContent = card.getAttribute('data-price-now') || '';
      if (heroCtaWas) {
        var hw = card.getAttribute('data-price-was') || '';
        heroCtaWas.textContent = hw;
        heroCtaWas.style.display = hw ? '' : 'none';
      }
      if (bubble) bubble.textContent = card.getAttribute('data-save-bubble') || '';
      if (headerSave) headerSave.textContent = card.getAttribute('data-save-header') || '';
      syncHeroCtaPriceLine(
        card.getAttribute('data-price-now') || '',
        card.getAttribute('data-price-was') || '',
        card.getAttribute('data-save-bubble') || '',
        card.getAttribute('data-save-header') || ''
      );
      syncBundleCardAriaLabels();
      updateVariantDrawerIfOpen();
      if (typeof root.cglpSyncDrawerBundles === 'function') {
        root.cglpSyncDrawerBundles();
      }
      attachCouponForBundle();
      if (shineBtn) {
        shineBtn.style.transform = 'scale(1.02)';
        window.setTimeout(function () {
          shineBtn.style.transform = '';
        }, 150);
      }
      syncBundleCheckoutFromCard(card);
    }

    var bundlesOpenDrawerHead = root.querySelector('[data-cglp-bundles-open-drawer]');
    if (bundlesOpenDrawerHead) {
      bundlesOpenDrawerHead.addEventListener('click', function (e) {
        if (!hasCartProduct || !variantData.length) return;
        e.preventDefault();
        tryOpenVariantDrawer(bundlesOpenDrawerHead);
      });
      bundlesOpenDrawerHead.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (!hasCartProduct || !variantData.length) return;
        tryOpenVariantDrawer(bundlesOpenDrawerHead);
      });
    }

    /* ── Hero bundle picker + sticky bar (used by wrapped selectBundle) ── */
    var heroPicks = root.querySelectorAll('[data-cglp-hero-pick]');
    function syncHeroPicksFromCard() {
      var sel = root.querySelector('.cglp-bundle-card.is-selected');
      if (!sel) return;
      var bc = parseInt(sel.getAttribute('data-bottle-count'), 10) || 0;
      heroPicks.forEach(function (p) {
        var pbc = parseInt(p.getAttribute('data-bottle-count'), 10) || 0;
        var match = pbc === bc;
        p.classList.toggle('is-selected', match);
        p.setAttribute('aria-checked', match ? 'true' : 'false');
      });
    }

    var stickyCta = root.querySelector('[data-cglp-sticky-cta]');
    if (!stickyCta) stickyCta = document.querySelector('[data-cglp-sticky-cta]');
    var stickyPrice = stickyCta ? stickyCta.querySelector('[data-cglp-sticky-price]') : null;
    var stickyWas = stickyCta ? stickyCta.querySelector('[data-cglp-sticky-was]') : null;

    function syncStickyPrices() {
      if (!stickyPrice || !stickyWas) return;
      var sel = root.querySelector('.cglp-bundle-card.is-selected');
      if (sel) {
        stickyPrice.textContent = sel.getAttribute('data-price-now') || '';
        stickyWas.textContent = sel.getAttribute('data-price-was') || '';
        return;
      }
      var hp = root.querySelector('[data-cglp-hero-pick].is-selected');
      if (hp) {
        stickyPrice.textContent = hp.getAttribute('data-pick-price-now') || '';
        stickyWas.textContent = hp.getAttribute('data-pick-price-was') || '';
      }
    }

    /* ── CRO audit #11 — promo code synced to selected bundle ──
       The CTA trust strip renders a <span data-cglp-promo-text
       data-cglp-promo-template="…{code}… {pct}…"> whose text updates on
       every bundle/hero-pick selection. We substitute two placeholders:
         {pct}  — derived from data-save-bubble ("20% OFF" → "20") with a
                  fallback to data-discount-pct. Bubble text is the most
                  reliable source because Drops leaves discount_pct at 0.
         {code} — the real Shopify discount code (1for10/2for20/3for30)
                  read from root data-cglp-coupon-{N} (same source the
                  checkout redirect + liquid-ajax-cart use). This keeps
                  the DISPLAYED promo honest with what's actually applied
                  at checkout — prevents the GLOW20 / 2for20 mismatch. */
    var promoTextEls = document.querySelectorAll('[data-cglp-promo-text]');
    function extractPctFromBubble(text) {
      if (!text) return null;
      var m = String(text).match(/(\d+)/);
      return m ? m[1] : null;
    }
    function resolveCouponCodeForQty(qty) {
      var n = parseInt(qty, 10);
      if (isNaN(n) || n < 1) return '';
      var attr = n <= 1 ? 'data-cglp-coupon-1'
               : n === 2 ? 'data-cglp-coupon-2'
               : 'data-cglp-coupon-3';
      return (root.getAttribute(attr) || '').trim();
    }
    function applyPromoTemplate(pct, code) {
      if (!promoTextEls || !promoTextEls.length) return;
      promoTextEls.forEach(function (el) {
        var tpl = el.getAttribute('data-cglp-promo-template') || el.textContent || '';
        var out = tpl;
        if (pct) out = out.replace(/\{pct\}/g, pct);
        if (code) out = out.replace(/\{code\}/g, code);
        el.textContent = out;
      });
    }
    function syncPromoCodeFromCard(card) {
      if (!promoTextEls || !promoTextEls.length || !card) return;
      var pct = extractPctFromBubble(card.getAttribute('data-save-bubble'));
      if (!pct) {
        var raw = parseInt(card.getAttribute('data-discount-pct'), 10);
        if (!isNaN(raw) && raw > 0) pct = String(raw);
      }
      var code = card.getAttribute('data-discount-code') || '';
      if (!code) {
        var qty = card.getAttribute('data-bottle-count') || card.getAttribute('data-qty');
        code = resolveCouponCodeForQty(qty);
      }
      if (!pct && !code) return;
      applyPromoTemplate(pct, code);
    }
    function syncPromoCodeFromHeroPick(pick) {
      if (!promoTextEls || !promoTextEls.length || !pick) return;
      var pct = extractPctFromBubble(pick.getAttribute('data-save-bubble'));
      if (!pct) {
        var raw = parseInt(pick.getAttribute('data-discount-pct'), 10);
        if (!isNaN(raw) && raw > 0) pct = String(raw);
      }
      var code = resolveCouponCodeForQty(pick.getAttribute('data-bottle-count'));
      if (!pct && !code) return;
      applyPromoTemplate(pct, code);
    }

    var origSelectBundle = selectBundle;
    selectBundle = function (card) {
      origSelectBundle(card);
      syncHeroPicksFromCard();
      syncStickyPrices();
      syncPromoCodeFromCard(card);
    };

    function syncEconomyFromHeroPick(pick) {
      if (!pick) return;
      var now = pick.getAttribute('data-pick-price-now') || '';
      var was = pick.getAttribute('data-pick-price-was') || '';
      if (priceNow) priceNow.textContent = now;
      if (priceWas) priceWas.textContent = was;
      if (heroCtaNow) heroCtaNow.textContent = now;
      if (heroCtaWas) {
        heroCtaWas.textContent = was;
        heroCtaWas.style.display = was ? '' : 'none';
      }
      if (bubble) bubble.textContent = pick.getAttribute('data-save-bubble') || '';
      if (headerSave) headerSave.textContent = pick.getAttribute('data-save-header') || '';
      syncHeroCtaPriceLine(
        now,
        was,
        pick.getAttribute('data-save-bubble') || '',
        pick.getAttribute('data-save-header') || ''
      );
      syncBundleCardAriaLabels();
      updateVariantDrawerIfOpen();
      if (typeof root.cglpSyncDrawerBundles === 'function') {
        root.cglpSyncDrawerBundles();
      }
      attachCouponForBundle();
      syncStickyPrices();
      syncPromoCodeFromHeroPick(pick);
      if (shineBtn) {
        shineBtn.style.transform = 'scale(1.02)';
        window.setTimeout(function () {
          shineBtn.style.transform = '';
        }, 150);
      }
    }

    function selectHeroPick(pick) {
      var bc = parseInt(pick.getAttribute('data-bottle-count'), 10) || 1;
      var matchCard = null;
      cards.forEach(function (c) {
        var cbc = parseInt(c.getAttribute('data-bottle-count'), 10) || 0;
        if (cbc === bc) matchCard = c;
      });
      if (matchCard) {
        selectBundle(matchCard);
        return;
      }
      if (!cards.length) {
        heroPicks.forEach(function (p) {
          var isSel = p === pick;
          p.classList.toggle('is-selected', isSel);
          p.setAttribute('aria-checked', isSel ? 'true' : 'false');
        });
        syncEconomyFromHeroPick(pick);
      }
    }

    function focusHeroPickAt(delta) {
      var picks = Array.prototype.slice.call(heroPicks);
      if (!picks.length) return;
      var cur = picks.indexOf(document.activeElement);
      if (cur < 0) {
        cur = picks.findIndex(function (p) {
          return p.classList.contains('is-selected');
        });
      }
      if (cur < 0) cur = 0;
      var next = cur + delta;
      if (next < 0) next = picks.length - 1;
      if (next >= picks.length) next = 0;
      var el = picks[next];
      if (el) {
        selectHeroPick(el);
        el.focus();
      }
    }

    heroPicks.forEach(function (pick) {
      pick.addEventListener('click', function () {
        selectHeroPick(pick);
      });
      pick.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          focusHeroPickAt(1);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          focusHeroPickAt(-1);
        } else if (e.key === 'Home') {
          e.preventDefault();
          var first = heroPicks[0];
          if (first) {
            selectHeroPick(first);
            first.focus();
          }
        } else if (e.key === 'End') {
          e.preventDefault();
          var last = heroPicks[heroPicks.length - 1];
          if (last) {
            selectHeroPick(last);
            last.focus();
          }
        }
      });
    });

    /* Sprint 5C P1.5: inline shade radiogroup rendered under the hero
       bundle-picker. Picking a shade here reuses the existing
       `selectVariantRow` state machine (sets selectedVariantId, updates sticky
       title, renders selling-plan options) so the hero CTA can skip the
       variant drawer entirely. The drawer still works as a fallback. */
    var inlineShadeOpts = Array.prototype.slice.call(
      root.querySelectorAll('[data-cglp-hero-shade-opt]')
    );

    function getAvailableInlineShades() {
      return inlineShadeOpts.filter(function (b) {
        return b.getAttribute('data-variant-available') !== 'false';
      });
    }

    function selectInlineShade(btn, opts) {
      if (!btn) return;
      if (btn.getAttribute('data-variant-available') === 'false') {
        btn.setAttribute('aria-disabled', 'true');
        return;
      }
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      inlineShadeOpts.forEach(function (sib) {
        var isMatch = sib === btn;
        sib.classList.toggle('is-selected', isMatch);
        sib.setAttribute('aria-checked', isMatch ? 'true' : 'false');
      });
      inlineShadeVariantId = variantId;
      if (typeof selectVariantRow === 'function') {
        selectVariantRow(variantId);
      }
      if (opts && opts.focus) {
        try {
          btn.focus({ preventScroll: true });
        } catch (err) {
          btn.focus();
        }
      }
    }

    function focusInlineShadeAt(fromBtn, delta) {
      var avail = getAvailableInlineShades();
      if (!avail.length) return;
      var cur = avail.indexOf(fromBtn);
      if (cur < 0) {
        for (var i = 0; i < avail.length; i++) {
          if (avail[i].classList.contains('is-selected')) { cur = i; break; }
        }
      }
      if (cur < 0) cur = 0;
      var next = cur + delta;
      if (next < 0) next = avail.length - 1;
      if (next >= avail.length) next = 0;
      selectInlineShade(avail[next], { focus: true });
    }

    inlineShadeOpts.forEach(function (btn) {
      if (btn.getAttribute('data-variant-available') === 'false') {
        btn.setAttribute('aria-disabled', 'true');
      }
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-variant-available') === 'false') return;
        selectInlineShade(btn);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
          if (btn.getAttribute('data-variant-available') === 'false') return;
          e.preventDefault();
          selectInlineShade(btn);
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          focusInlineShadeAt(btn, 1);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          focusInlineShadeAt(btn, -1);
        } else if (e.key === 'Home') {
          e.preventDefault();
          var firstAvail = getAvailableInlineShades()[0];
          if (firstAvail) selectInlineShade(firstAvail, { focus: true });
        } else if (e.key === 'End') {
          e.preventDefault();
          var availEnd = getAvailableInlineShades();
          var lastAvail = availEnd[availEnd.length - 1];
          if (lastAvail) selectInlineShade(lastAvail, { focus: true });
        }
      });
    });

    /* Default the inline shade picker to Medium (first available; falls back
       to the first available option) so there is no unselected state. */
    if (inlineShadeOpts.length && !inlineShadeOpts.some(function (b) {
      return b.classList.contains('is-selected');
    })) {
      var availDefaults = getAvailableInlineShades();
      var mediumDefault = null;
      for (var di = 0; di < availDefaults.length; di++) {
        if (/medium/i.test(availDefaults[di].textContent || '')) {
          mediumDefault = availDefaults[di];
          break;
        }
      }
      var defaultShadeBtn = mediumDefault || availDefaults[0] || null;
      if (defaultShadeBtn) selectInlineShade(defaultShadeBtn);
    }

    root.cglpSelectShade = function (variantId) {
      for (var i = 0; i < inlineShadeOpts.length; i++) {
        if (inlineShadeOpts[i].getAttribute('data-variant-id') === String(variantId)) {
          selectInlineShade(inlineShadeOpts[i]);
          return;
        }
      }
    };
    root.cglpDirectAddToCartAndCheckout = directAddToCartAndCheckout;

    /* P1.5 — shade picker tooltip toggle. Click / key toggles; outside
       click + Escape dismiss. Non-interfering with existing hotspot logic. */
    var shadeTooltipTriggers = Array.prototype.slice.call(
      root.querySelectorAll('[data-cglp-tooltip]'),
    );
    shadeTooltipTriggers.forEach(function (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      if (!panelId) return;
      var panel = root.querySelector('#' + CSS.escape(panelId));
      if (!panel) return;
      function openPanel() {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
      function closePanel() {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (trigger.getAttribute('aria-expanded') === 'true') closePanel();
        else openPanel();
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePanel();
      });
      document.addEventListener('click', function (e) {
        if (panel.hidden) return;
        if (e.target === trigger || panel.contains(e.target) || trigger.contains(e.target)) return;
        closePanel();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) closePanel();
      });
    });

    /* Hero review hotspots (ai-lp style rotation) */
    var heroHotspots = Array.prototype.slice.call(root.querySelectorAll('[data-cglp-hero-hotspot]'));
    if (heroHotspots.length) {
      var heroHotspotIdx = 0;
      var clearHeroHotspotState = function () {
        heroHotspots.forEach(function (hs) {
          var tip = hs.querySelector('[data-cglp-hero-tooltip]');
          var triggerEl = hs.querySelector('.cglp-hero-hotspot__trigger');
          hs.classList.remove('is-active');
          if (tip) tip.classList.remove('is-active');
          if (triggerEl) triggerEl.setAttribute('aria-expanded', 'false');
        });
      };
      var showHeroHotspot = function (idx) {
        clearHeroHotspotState();
        var hs = heroHotspots[idx];
        if (!hs) return;
        var tip = hs.querySelector('[data-cglp-hero-tooltip]');
        var triggerEl = hs.querySelector('.cglp-hero-hotspot__trigger');
        if (tip) {
          hs.classList.add('is-active');
          tip.classList.add('is-active');
          if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
          window.setTimeout(function () {
            if (document.activeElement === triggerEl) return;
            hs.classList.remove('is-active');
            tip.classList.remove('is-active');
            if (triggerEl) triggerEl.setAttribute('aria-expanded', 'false');
          }, 4000);
        }
      };
      showHeroHotspot(0);
      if (!prefersReducedMotion && heroHotspots.length > 1) {
        heroHotspotRotateId = window.setInterval(function () {
          heroHotspotIdx = (heroHotspotIdx + 1) % heroHotspots.length;
          showHeroHotspot(heroHotspotIdx);
        }, 6000);
      }
      heroHotspots.forEach(function (hs, idx) {
        var trigger = hs.querySelector('.cglp-hero-hotspot__trigger');
        if (!trigger) return;
        trigger.addEventListener('focus', function () {
          heroHotspotIdx = idx;
          showHeroHotspot(heroHotspotIdx);
        });
        trigger.addEventListener('blur', function () {
          var tip = hs.querySelector('[data-cglp-hero-tooltip]');
          hs.classList.remove('is-active');
          if (tip) tip.classList.remove('is-active');
          trigger.setAttribute('aria-expanded', 'false');
        });
        trigger.addEventListener('click', function () {
          heroHotspotIdx = idx;
          showHeroHotspot(heroHotspotIdx);
        });
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            heroHotspotIdx = idx;
            showHeroHotspot(heroHotspotIdx);
          }
        });
      });
    }

    var stickyCtaScrollHandler = null;
    if (stickyCta) {
      var heroCtaBtn = root.querySelector('.cglp-btn-black--hero');
      var stickyVisible = false;
      stickyCtaScrollHandler = function () {
        if (!heroCtaBtn) return;
        var rect = heroCtaBtn.getBoundingClientRect();
        var headerEl = root.querySelector('.cglp-header');
        var headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;
        var shouldShow = rect.top <= headerHeight;
        if (shouldShow !== stickyVisible) {
          stickyVisible = shouldShow;
          stickyCta.removeAttribute('hidden');
          stickyCta.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          stickyCta.classList.toggle('is-visible', shouldShow);
          root.classList.toggle('cglp-has-sticky-cta', shouldShow);
        }
      };
      window.addEventListener('scroll', stickyCtaScrollHandler, { passive: true });
      stickyCtaScrollHandler();
    }

    function syncHeaderOffset() {
      var header = root.querySelector('.cglp-header');
      var configuredMobile = parseInt(root.getAttribute('data-cglp-layout-offset-mobile'), 10) || 0;
      var configuredDesktop = parseInt(root.getAttribute('data-cglp-layout-offset-desktop'), 10) || 0;
      var configured = window.innerWidth >= 768 ? configuredDesktop : configuredMobile;
      if (!header) {
        root.style.paddingTop = configured > 0 ? configured + 'px' : '0px';
        return;
      }
      var h = Math.ceil(header.getBoundingClientRect().height || 0);
      root.style.paddingTop = Math.max(h, configured) + 'px';
    }
    syncHeaderOffset();
    window.addEventListener('resize', syncHeaderOffset);
    window.setTimeout(syncHeaderOffset, 120);

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectBundle(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectBundle(card);
        }
      });
    });

    var defaultCard = root.querySelector('.cglp-bundle-card.is-selected') || cards[0];
    if (defaultCard) selectBundle(defaultCard);
    else if (cards.length) syncBundleCardAriaLabels();
    else if (heroPicks.length) {
      var defaultPick =
        root.querySelector('[data-cglp-hero-pick].is-selected') || heroPicks[0];
      if (defaultPick) selectHeroPick(defaultPick);
    }

    if (hasCartProduct && variantData.length) {
      var firstAvailId = null;
      for (var vix = 0; vix < variantData.length; vix++) {
        if (variantData[vix].available) {
          firstAvailId = variantData[vix].id;
          break;
        }
      }
      if (firstAvailId != null) updateStickyVariantTitle(firstAvailId);
    }

    /* Before / after */
    var baContainer = root.querySelector('[data-cglp-ba-slider]');
    var baOverlay = root.querySelector('[data-cglp-ba-overlay]');
    var baHandle = root.querySelector('[data-cglp-ba-handle]');
    var baPct = 50;

    function setBaAria(pct) {
      if (!baContainer) return;
      var rounded = Math.round(pct);
      baContainer.setAttribute('aria-valuenow', String(rounded));
      baContainer.setAttribute(
        'aria-valuetext',
        'Before image visible across ' + rounded + ' percent of the frame'
      );
    }

    function applyBaPct(pct) {
      if (!baOverlay || !baHandle) return;
      baPct = Math.max(0, Math.min(100, pct));
      baOverlay.style.width = baPct + '%';
      baHandle.style.left = baPct + '%';
      setBaAria(baPct);
    }

    function moveBa(clientX) {
      if (!baContainer || !baOverlay || !baHandle) return;
      var rect = baContainer.getBoundingClientRect();
      var x = clientX - rect.left;
      if (x < 0) x = 0;
      if (x > rect.width) x = rect.width;
      var pct = rect.width ? (x / rect.width) * 100 : 50;
      applyBaPct(pct);
    }

    if (baContainer) {
      applyBaPct(baPct);
      var baIsDragging = false;
      function baOnDocMove(ev) {
        if (!baIsDragging) return;
        moveBa(ev.clientX);
      }
      function baOnDocUp() {
        baIsDragging = false;
        document.removeEventListener('mousemove', baOnDocMove);
        document.removeEventListener('mouseup', baOnDocUp);
      }
      baContainer.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        baIsDragging = true;
        e.preventDefault();
        moveBa(e.clientX);
        document.addEventListener('mousemove', baOnDocMove);
        document.addEventListener('mouseup', baOnDocUp);
      });
      /* Suppress native image-drag ghost that hijacks interaction on desktop. */
      baContainer.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
      baContainer.addEventListener(
        'touchstart',
        function (e) {
          if (e.touches[0]) moveBa(e.touches[0].clientX);
        },
        { passive: true }
      );
      baContainer.addEventListener(
        'touchmove',
        function (e) {
          if (e.touches[0]) moveBa(e.touches[0].clientX);
        },
        { passive: true }
      );
      baContainer.addEventListener('keydown', function (e) {
        if (!baOverlay || !baHandle) return;
        var step = 5;
        var next = baPct;
        if (e.key === 'ArrowLeft' || e.key === 'Left') {
          next = baPct - step;
          e.preventDefault();
        } else if (e.key === 'ArrowRight' || e.key === 'Right') {
          next = baPct + step;
          e.preventDefault();
        } else if (e.key === 'Home') {
          next = 0;
          e.preventDefault();
        } else if (e.key === 'End') {
          next = 100;
          e.preventDefault();
        } else {
          return;
        }
        applyBaPct(next);
      });
    }

    /* Toast */
    var toast = root.querySelector('[data-cglp-toast]');
    var toastMsg = root.querySelector('[data-cglp-toast-message]');

    function showToast(message) {
      if (!toast) return;
      if (toastMsg && message) toastMsg.textContent = message;
      toast.classList.add('is-visible');
      toast.style.opacity = '1';
      toast.style.top = '120px';
      window.setTimeout(function () {
        toast.classList.remove('is-visible');
        toast.style.opacity = '0';
        toast.style.top = '6rem';
      }, 2000);
    }

    if (shineBtn && !hasCartProduct) {
      shineBtn.addEventListener('click', function () {
        var msg = shineBtn.getAttribute('data-toast-message') || 'Adding Selection...';
        showToast(msg);
      });
    }

    /* Optional: play button opens section tutorial URL (when preview is a photo step) */
    if (playBtn) {
      playBtn.addEventListener('click', function () {
        var url = playBtn.getAttribute('data-video-url');
        if (url) window.open(url, '_blank', 'noopener');
      });
    }

    document.addEventListener('shopify:section:unload', function (ev) {
      if (!(ev.target instanceof Element) || !ev.target.contains(root)) return;
      if (reserveTimerId) {
        window.clearInterval(reserveTimerId);
        reserveTimerId = null;
      }
      if (drawerTimerId) {
        window.clearInterval(drawerTimerId);
        drawerTimerId = null;
      }
      if (heroOffersRotateId) {
        window.clearInterval(heroOffersRotateId);
        heroOffersRotateId = null;
      }
      if (heroHotspotRotateId) {
        window.clearInterval(heroHotspotRotateId);
        heroHotspotRotateId = null;
      }
      window.removeEventListener('resize', syncHeaderOffset);
      if (stickyCtaScrollHandler) {
        window.removeEventListener('scroll', stickyCtaScrollHandler);
        stickyCtaScrollHandler = null;
      }
      document.removeEventListener('visibilitychange', onPreviewVidVisibilityChange);
      /* Ensure drawer-related document listeners + html class are cleared when the
         merchant swaps/reloads the section in the theme editor while it is open. */
      document.removeEventListener('keydown', onDrawerKeydown);
      document.documentElement.classList.remove('cglp-variant-drawer-open');
      disconnectPreviewVidIO();
      if (previewVid) {
        if (typeof previewVid.pause === 'function') previewVid.pause();
        if (previewVid._cglpEndedHandler) {
          previewVid.removeEventListener('ended', previewVid._cglpEndedHandler);
          previewVid._cglpEndedHandler = null;
        }
      }
    });
  }

  function initAllCleanGlowRoots() {
    document.querySelectorAll('[data-clean-glow-landing], [data-bbe-landing-root]').forEach(function (node) {
      initCleanGlowLanding(node);
    });
  }

  initAllCleanGlowRoots();

  document.addEventListener('shopify:section:load', function (event) {
    var el =
      event.target.querySelector('[data-clean-glow-landing]') ||
      event.target.querySelector('[data-bbe-landing-root]');
    if (el) initCleanGlowLanding(el);
  });
})();
